import { CardProps } from '@material-ui/core'
import { EnumCommodity } from '../../../../api'

export type PriceComponentsCardProps = PriceComponentsCardBase
// | PriceComponentsCardByContract
// | PriceComponentsCardByFlexibility

export interface PriceComponentsCardBase extends CardProps {
  contractId?: number
  flexibilityId?: number
  leadId?: number
  commodityId?: EnumCommodity // needed to fetch LeadOptions
  style?: React.CSSProperties
  insideTooltip?: boolean
  onRetry: () => void
}

export namespace ComponentCardAddButtonOptions {
  export const PARAMETER = 'PARAMETER'
  export const COEFFICIENT = 'COEFFICIENT'
  export const PARAMETER_PERIOD = 'PARAMETER_PERIOD'
}

export type ComponentCardAddButtonOptions =
  (typeof ComponentCardAddButtonOptions)[keyof typeof ComponentCardAddButtonOptions]
